import { render, staticRenderFns } from "./pension-providers.vue?vue&type=template&id=3d938740&"
import script from "./pension-providers.vue?vue&type=script&lang=js&"
export * from "./pension-providers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports